import ChangePhoneForm from './ChangePhoneForm/ChangePhoneForm';
import LoginFormContainer from 'tailwind-components/LoginFormContainer/LoginFormContainer';
import PropTypes from 'prop-types';
import React from 'react';
import SecondaryPage from 'components/SecondaryPage/SecondaryPage';

function ChangePhone({
  userCredentials = null,
  setResolver = null,
  setUserCredentials = null,
  setVerificationId = null
}) {
  return (
    <SecondaryPage>
      <LoginFormContainer width='600px'>
        <ChangePhoneForm
          userCredentials={userCredentials}
          setResolver={setResolver}
          setUserCredentials={setUserCredentials}
          setVerificationId={setVerificationId}
        />
      </LoginFormContainer>
    </SecondaryPage>
  );
}

ChangePhone.propTypes = {
  userCredentials: PropTypes.object,
  setResolver: PropTypes.func,
  setUserCredentials: PropTypes.func,
  setVerificationId: PropTypes.func,
  setPhoneNumber: PropTypes.func,
  resolver: PropTypes.object
};

export default ChangePhone;
